<template>
  <div class="ActiveTab__Header">
    <div class="ActiveTab__Eyebrow">
      Locatie ID: {{ `${chargingpoint.code}-${chargingpoint.properties.id}` }}
      <img
        :src="legendIcon"
        class="ActiveTab__Eyebrow__Icon"
        width="15"
        alt=""
      >
      <i
        v-if="isBoundToProcess"
        class="fas fa-lock ActiveTab__Eyebrow__Lock"
      />
    </div>

    <slot />
  </div>
</template>

<script>
import { image } from '@/helpers/assets'

export default {
  props: {
    chargingpoint: {
      type: Object,
      required: true,
    },
  },
  computed: {
    legendIcon: function () {
      return image({
        name: `chargingpoint/png/${this.chargingpoint.properties.status}.png`,
      })
    },
    isBoundToProcess() {
      return !!this.chargingpoint.workflowCaseRef ||
        !!this.chargingpoint.workflowUuid ||
        !!this.chargingpoint.externalProcessId ||
        !!this.chargingpoint.isLockedForEditing
    },
  },
}
</script>
<style lang="scss">
.ActiveTab__Eyebrow {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: .95rem;
  color: var(--text-muted);
}
.ActiveTab__Eyebrow__Icon {
  margin-left: 0.5rem;
}
.ActiveTab__Eyebrow__Lock {
  margin-left: 0.5rem;
  color: var(--warning);
}
</style>
